import axios from 'axios';

export default {
  fetchTraining() {
    return axios.get('/training')
      .then(res => res);
  },
};
